import type { eventWithTime } from '@carboncopyco/rrweb-types';
import type { Tour } from '@carboncopyco/types';
import { getFlickerProcessedEvents } from './getFlickerProcessedEvents';

export const processEvents = async (
  events: eventWithTime[],
  fileServiceToken: Tour['fileServiceToken'],
  options: { inlineStyles: boolean }
) => {
  if (!Object.values(options).some(Boolean)) {
    return events;
  }

  if (options.inlineStyles) {
    return await getFlickerProcessedEvents(events, fileServiceToken);
  }

  return events;
};
